module.exports = __webpack_public_path__ + "static/media/tw-logo-dark.dd14b9b5.svg";